import React from 'react';

interface Icon3DWrenchProps {
  size?: string;
}

const Icon3DWrench: React.FC<Icon3DWrenchProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'spin-wrench 2s linear infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg 
          viewBox="0 0 24 24" 
          fill="none" 
          className="w-full h-full"
          style={{
            filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.2))'
          }}
        >
          <defs>
            <linearGradient id="wrenchGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#6366f1" />
              <stop offset="100%" stopColor="#4f46e5" />
            </linearGradient>
          </defs>
          <rect x="4" y="8" width="14" height="3" rx="1.5" fill="url(#wrenchGradient)" />
          <circle cx="18" cy="9.5" r="2.5" fill="url(#wrenchGradient)" />
        </svg>
        <style>{`
          @keyframes spin-wrench {
            0% { transform: rotateZ(0deg); }
            100% { transform: rotateZ(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DWrench;
